export const FJD_DOCS_EINRICHTUNGSASSISTANT =
  'https://docs.efast.digital/bhbeh/einrichten-eines-mandanten';
export const FJD_DOCS_SETTINGS_FOOTERLINKS =
  'https://docs.efast.digital/bhbeh/verwalten-eines-mandanten#VerwalteneinesMandanten-Footerlinks';
export const FJD_DOCS_SETTINGS_FITCONNECT =
  'https://docs.efast.digital/bhbeh/verwalten-eines-mandanten#VerwalteneinesMandanten-FIT-Connect-Konfiguration';
export const FITCONNECT_DOCS_KEYS =
  'https://docs.fitko.de/fit-connect/docs/receiving/destination#sicherheit';
export const FIT_CONNECT_CLIENT_DOCS =
  'https://docs.fitko.de/fit-connect/docs/getting-started/account#zugangsdaten-f%C3%BCr-verwaltungssysteme';
export const FITCONNECT_SSP_SUBSCRIBER_CLIENTS =
  'https://portal.auth-prod.fit-connect.fitko.net/clients?type=SUBSCRIBER';
export const FITCONNECT_SSP_SENDER_CLIENTS =
  'https://portal.auth-prod.fit-connect.fitko.net/clients?type=SENDER';
export const BUNDID_ANBINDUNGSLEITFADEN_DOCS =
  'https://ssp.id.bund.de/ip/de/bundid-anbindungsleitfaden?id=kb_article_view&sysparm_article=KB0010307';
